const BOGGLE_DEV_SEARCH_TRUE_VALUES = new Set(['', '1', 'true', 'yes', 'on'])

/** In-memory only: survives SPA navigations, clears on full page reload. */
const boggleDevModeNavigationMemory = {
  enabled: false,
}

function isTruthyDevSearchValue(value: string) {
  return BOGGLE_DEV_SEARCH_TRUE_VALUES.has(value.trim().toLowerCase())
}

function isExplicitDevDisabled(value: unknown): boolean {
  if (value === false) {
    return true
  }

  if (typeof value !== 'string') {
    return false
  }

  const normalized = value.trim().toLowerCase()
  return normalized === '0' || normalized === 'false' || normalized === 'no' || normalized === 'off'
}

export function hasBoggleDevSearchFlag(value: unknown): boolean {
  if (Array.isArray(value)) {
    return value.some(entry => hasBoggleDevSearchFlag(entry))
  }

  if (value === true) {
    return true
  }

  if (typeof value !== 'string') {
    return false
  }

  return isTruthyDevSearchValue(value)
}

export function validateBoggleDevSearch(search: Record<string, unknown>) {
  return {
    dev: hasBoggleDevSearchFlag(search.dev),
  }
}

/**
 * Call on each navigation so `?dev` turns dev mode on for this page load and `?dev=false` (etc.) clears it.
 * When the URL omits `dev`, in-memory dev mode stays until explicitly cleared. Lost on full refresh.
 */
export function syncBoggleDevModeFromSearch(search: Record<string, unknown>) {
  if (typeof window === 'undefined') {
    return
  }

  if (hasBoggleDevSearchFlag(search.dev)) {
    boggleDevModeNavigationMemory.enabled = true
  } else if (isExplicitDevDisabled(search.dev)) {
    boggleDevModeNavigationMemory.enabled = false
  }
}

export function readBoggleDevModeNavigationMemory(): boolean {
  return boggleDevModeNavigationMemory.enabled
}

/** Test-only: reset module memory between tests. */
export function resetBoggleDevModeNavigationMemoryForTests() {
  boggleDevModeNavigationMemory.enabled = false
}

export function resolveBoggleDevMode(
  searchDevFlag: unknown,
  isViteDev = import.meta.env.DEV,
  navigationMemory = false,
) {
  return isViteDev || hasBoggleDevSearchFlag(searchDevFlag) || navigationMemory
}

/** Dev-only: when Vite dev build and `?free` (or `?free=1` / true / on) is set, accepts any path as a dictionary word. */
export function resolveBoggleDevFreeDictionary(
  searchFreeFlag: unknown,
  isViteDev = import.meta.env.DEV,
) {
  return isViteDev && hasBoggleDevSearchFlag(searchFreeFlag)
}
